<template>
	<div v-if="defaultAttribute !== null" class="input-like flex items-center justify-between gap-3">
		<p>{{ defaultAttribute }}</p>
		<button class="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300" @click.stop="clearSelection">
			<i class="fa-solid fa-xmark"/>
		</button>
	</div>
	<div v-else :class="`relative ${full ? 'w-full grow' : 'w-fit'}`" @click.stop="typed = false">
		<input v-model="searchTerm" type="text" :class="`${full ? 'w-full' : 'w-fit'}`" @click.stop="typed = true">
		<DropdownContainerExposed v-if="filteredItems.length > 0" :id="id" :right="right" :up="up">
			<DropdownItem v-for="item in filteredItems" :key="`${id}-item-${item.id}`" @click.stop="selectItem(item)">
				{{ item[searchAttribute] }}
			</DropdownItem>
		</DropdownContainerExposed>
	</div>
</template>
<script setup lang="ts">
import {type Model} from '@/Types/Model'
import {fuzzyMatch} from '@/Helpers/general'
import DropdownItem from '@/Components/UI/Dropdown/DropdownItem.vue'
import {computed, type ComputedRef, defineEmits, defineProps, ref, type Ref} from 'vue'
import DropdownContainerExposed from '@/Components/UI/Dropdown/DropdownContainerExposed.vue'

const props = defineProps<{
	id:string,
	up?:boolean,
	full?:boolean,
	right?:boolean,
	items:Array<Model>,
	searchAttribute:string,
	defaultAttribute?:string,
}>()

const emit = defineEmits([
	'select',
])

const typed:Ref<boolean> = ref(false)
const id:Ref<string> = ref(props.id)
const up:Ref<boolean> = ref(props.up)
const right:Ref<boolean> = ref(props.right)
const searchTerm:Ref<string> = ref(props.defaultAttribute ?? '')
const defaultAttribute:Ref<string|null> = ref(props.defaultAttribute ?? null)

const filteredItems:ComputedRef<Array<Model>> = computed(():Array<Model> => {
	if(!typed.value){
		return []
	}
	return props.items.filter((m:Model) => fuzzyMatch(m[props.searchAttribute], searchTerm.value))
})

function selectItem(item:Model):void{
	searchTerm.value = ''
	emit('select', item)
}

function clearSelection():void{
	defaultAttribute.value = null
	searchTerm.value = ''
	emit('select', null)
}
</script>